/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    holdings: `/holdings`,
    services: `/services`,
    utilities: `/utilities`,
    transfer: `/transfer`,
};

/**
 * Experience API 업무구분 URL
 * @type {string}
 */
const sectors = {
    holdings: {
        funds: `${packages.holdings}/funds`,
        deposits: `${packages.holdings}/deposits`,
        assets: `${packages.holdings}/assets`,
    },
    services: {
        funds: `${packages.services}/funds`,
    },
    utilities: {
        functions: `${packages.utilities}/functions`,
    },
    transfer: {
        schedule: `${packages.transfer}/schedule`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    holdings: {
        funds: {
            inquiry: `${sectors.holdings.funds}/inquiry`,
            myfund: `${sectors.holdings.funds}/myfund`,
            report: `${sectors.holdings.funds}/report`,
            notification: `${sectors.holdings.funds}/notification`,
            extension: `${sectors.holdings.funds}/extension`,
            autoTransfer: `${sectors.holdings.funds}/autoTransfer`,
            feeInquiry: `${sectors.holdings.funds}/feeInquiry`,
        },
        deposits: {
            findDetail: `${sectors.holdings.deposits}/findDetail`,
        },
        assets: {
            findList: `${sectors.holdings.assets}/findList`,
        },
    },
    services: {
        funds: {
            expectedRedemption: `${sectors.services.funds}/expectedRedemption`,
            additionalContribution: `${sectors.services.funds}/additionalContribution`,
            targetAutomaticRedemption: `${sectors.services.funds}/targetAutomaticRedemption`,
        },
    },
    utilities: {
        functions: {
            account: `${sectors.utilities.functions}/account`,
        },
    },
    transfer: {
        schedule: {
            findList: `${sectors.transfer.schedule}/findList`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    holdings: {
        funds: {
            inquiry: {
                getAccountInfo: `${details.holdings.funds.inquiry}/getAccountInfo`, //조회 > 펀드 > 계좌정보조회
                listAccountRateOfReturn: `${details.holdings.funds.inquiry}/listAccountRateOfReturn`, //조회 > 펀드 > 수익률
                listAccountTransaction: `${details.holdings.funds.inquiry}/listAccountTransaction`, //조회 > 펀드 > 거래내역조회
                listFundStatement: `${details.holdings.funds.inquiry}/listFundStatement`, //조회 > 펀드 > 펀드계산서 내역조회
                getFundStatement: `${details.holdings.funds.inquiry}/getFundStatement`, //조회 > 펀드 > 펀드계산서 상세조회
                getExpectedRedemption: `${details.holdings.funds.inquiry}/getExpectedRedemption`, //조회 > 펀드 > 환매예상조회/신청-예상조회
            },
            myfund: {
                listAccount: `${details.holdings.funds.myfund}/listAccount`, // 펀드 > 나의 펀드관리 > 나의 펀드자산
                getAccountInfo: `${details.holdings.funds.myfund}/getAccountInfo`, // 펀드 > 나의 펀드관리 > 나의 펀드자산 > 펀드계좌 상세조회
                getProductInfo: `${details.holdings.funds.myfund}/getProductInfo`, // 펀드 > 나의 펀드관리 > 나의 펀드자산 > 펀드상품 상세조회 팝업
                executePortfolioResult: `${details.holdings.funds.myfund}/executePortfolioResult`, // 펀드 > 나의 펀드관리 > 투자지역별, 자산유형별
                executeFitnessResult: `${details.holdings.funds.myfund}/executeFitnessResult`, // 펀드 > 나의 펀드관리 > 투자지역별, 자산유형별
                listCloseAccount: `${details.holdings.funds.myfund}/listCloseAccount`, // 펀드 > 나의 펀드관리 > 해지계좌조회
            },
            report: {
                listAccountExcludeMMF: `${details.holdings.funds.report}/listAccountExcludeMMF`, // 펀드 > 나의 실질투자수익률보고서 > 펀드계좌조회
                getAccountRateOfReturn: `${details.holdings.funds.report}/getAccountRateOfReturn`, // 펀드 > 나의 실질투자수익률보고서 >  수익률조회
                savePdfFile: `${details.holdings.funds.report}/savePdfFile`, // 펀드 > 나의 실질투자수익률보고서 > PDF생성
            },
            notification: {
                listAccount: `${details.holdings.funds.notification}/listAccount`, // 펀드 > 펀드통지서비스
                executeReportNotificationMethod: `${details.holdings.funds.notification}/executeReportNotificationMethod`, // 펀드 > 펀드통지서비스 > 통지서비스 선택(신청)
                notificationCancel: `${details.holdings.funds.notification}/notificationCancel`, // 펀드 > 펀드통지서비스 > 통지서비스 선택(변경) - 사용안함
                notificationRequestComplete: `${details.holdings.funds.notification}/notificationRequestComplete`, // 펀드 > 펀드통지서비스 > 서비스 신청 완료 - 사용안함
                notificationCancelComplete: `${details.holdings.funds.notification}/notificationCancelComplete`, // 펀드 > 펀드통지서비스 > 서비스 해제 완료 - 사용안함
            },
            extension: {
                excuteAccumulationFundExtensionPre: `${details.holdings.funds.extension}/excuteAccumulationFundExtensionPre`,
                excuteAccumulationFundExtensionMain: `${details.holdings.funds.extension}/excuteAccumulationFundExtensionMain`,
            },
            autoTransfer: {
                validateAccountPassword: `${details.holdings.funds.autoTransfer}/validateAccountPassword`, //자동이체 > 외화펀드 > 비밀번호검증
            },
            feeInquiry: {
                getFundsFee: `${details.holdings.funds.feeInquiry}/getFundsFee`,
            },
        },
        deposits: {
            findDetail: {
                //  출금계좌 정보(이체가능금액조회)
                getInfoByAccountNo: `${details.holdings.deposits.findDetail}/getInfoByAccountNo`,
            },
        },
        assets: {
            findList: {
                listMainAssets: `${details.holdings.assets.findList}/listMainAssets`,
            },
        },
    },
    services: {
        funds: {
            expectedRedemption: {
                executeTransferPre: `${details.services.funds.expectedRedemption}/executeTransferPre`, //조회 > 펀드 > 환매예상조회/신청 > 정보확인
                executeTransferMain: `${details.services.funds.expectedRedemption}/executeTransferMain`, //조회 > 펀드 > 환매예상조회/신청 > 거래완료
            },
            additionalContribution: {
                listWithdrawalAccount: `${details.services.funds.additionalContribution}/listWithdrawalAccount`,
                validateAccountCredential: `${details.services.funds.additionalContribution}/validateAccountCredential`,
                listAccount: `${details.services.funds.additionalContribution}/listAccount`,
                validateFundSuitable: `${details.services.funds.additionalContribution}/validateFundSuitable`, // 펀드 > 공통 > 적합성 체크
                getProspectus: `${details.services.funds.additionalContribution}/getProspectus`,
                executeTransferPre: `${details.services.funds.additionalContribution}/executeTransferPre`,
                executeSendEmail: `${details.services.funds.additionalContribution}/executeSendEmail`,
                confirmTransferInfo: `${details.services.funds.additionalContribution}/confirmTransferInfo`,
                executeTransferMain: `${details.services.funds.additionalContribution}/executeTransferMain`,
                getLinkedAccount: `${details.services.funds.additionalContribution}/getLinkedAccount`,
                validateAccountCredentialByFex: `${details.services.funds.additionalContribution}/validateAccountCredentialByFex`, //추가납입 > 외화펀드 > 비밀번호검증
                getProspectusByFex: `${details.services.funds.additionalContribution}/getProspectusByFex`, //추가납입 > 외화펀드 > 투자설명서조회
                getUpfrontFree: `${details.services.funds.additionalContribution}/getUpfrontFree`, //추가납입 > 외화펀드 > 선취수수료조회
                executeTransferPreByFex: `${details.services.funds.additionalContribution}/executeTransferPreByFex`, // 추가납입 > 외화펀드 > 예비거래
                executeTransferMainByFex: `${details.services.funds.additionalContribution}/executeTransferMainByFex`, // 추가납입 > 외화펀드 > 본거래
            },
            targetAutomaticRedemption: {
                listAccount: `${details.services.funds.targetAutomaticRedemption}/listAccount`, // 펀드 > 목표도달자동환매 > 펀드선택
                validateAccount: `${details.services.funds.targetAutomaticRedemption}/validateAccount`, // 펀드 > 목표도달자동환매 > 정보입력
                executeTransferMain: `${details.services.funds.targetAutomaticRedemption}/executeTransferMain`, // 펀드 > 목표도달자동환매 > 거래완료
            },
        },
    },
    utilities: {
        functions: {
            account: {
                list: `${details.utilities.functions.account}/list`,
            },
        },
    },
    transfer: {
        schedule: {
            findList: {
                //  자동이체 내역 조회
                listAutoTransfer: `${details.transfer.schedule.findList}/listAutoTransfer`,
            },
        },
    },
};
